module.exports = __webpack_public_path__ + "static/media/ig.8c16824e.svg";